export * from './faq.component'
